<template>
  <el-popover v-model="showPortalsFlag" popperClass="portal-popover" trigger="manual" width="80">
    <div class="portals">
      <div
        v-for="portal in portalNumbers"
        :key="portal"
        class="portal"
        type="text"
        @click="handleSetPortal(portal)"
      >
        {{ portal }}
      </div>
    </div>
    <el-input
      ref="input"
      slot="reference"
      v-model="internalValue"
      :disabled="$attrs.disabled"
      :tabindex="tabindex"
      @change="handleUpdatePortal"
    >
      <el-button
        slot="suffix"
        class="portals-dropdown-arrow"
        type="text"
        @click.stop="showPortalsFlag = !showPortalsFlag"
      >
        <el-icon v-if="showPortalsFlag" name="arrow-up" />
        <el-icon v-else name="arrow-down" />
      </el-button>
    </el-input>
  </el-popover>
</template>

<script>
import cache from "@/mixins/cache";
import { uniq } from "lodash";
import { sortByValue } from "@/utils/sorters";
import { off, on } from "element-ui/src/utils/dom";

export default {
  name: "PortalSelector",
  mixins: [cache],
  props: {
    value: [String, Number],
    street: Object,
    workgroupId: Number,
    tabindex: [String, Number],
  },
  data() {
    return {
      persistedCache: true,
      showPortalsFlag: false,
      internalValue: null,
    };
  },
  computed: {
    portalNumbers() {
      return uniq(this.portals.map((p) => p.number)).sort(sortByValue);
    },
    portals() {
      return this.street?.portals || [];
    },
  },
  watch: {
    value() {
      this.internalValue = this.value;
    },
  },
  created() {
    this.internalValue = this.value;
    on(document, "click", this.handleDocumentClick);
  },
  destroyed() {
    off(document, "click", this.handleDocumentClick);
  },
  methods: {
    handleSetPortal(portal) {
      this.internalValue = portal;
      this.showPortalsFlag = false;
      if (this.internalValue !== this.value) {
        this.$emit("input", parseInt(portal) >= 0 ? parseInt(portal) : null);
      }
    },
    handleUpdatePortal() {
      if (this.internalValue !== this.value) {
        this.$emit(
          "input",
          parseInt(this.internalValue) >= 0 ? parseInt(this.internalValue) : null
        );
      }
    },
    handleDocumentClick() {
      this.showPortalsFlag = false;
    },
  },
};
</script>

<style>
.portal-popover {
  min-width: auto;
}
</style>

<style lang="scss" scoped>
.portals-dropdown-arrow {
  right: 4px;
  top: -1px;
  font-size: 14px;
  position: absolute;
  color: #5a5b67;
}

.portals {
  display: flex;
  flex-direction: column;
  max-height: 210px;
  overflow-y: auto;
}

.portal {
  flex: 1;
  text-align: center;
  cursor: pointer;
  display: block;
  width: 100%;
  font-size: 12px;
  padding: 4px 0;

  &.active {
    font-weight: bold;
    color: $menuActiveText;
  }
}
</style>
